<template>
  <div class="container-edit-pagamento">
    <div v-if="!editing">
      {{value.valorPago | valorParaReal }} - {{ value.formaPagamento | filterEnum(formasPagamento)}} - {{ value.dataPagamento | filterDataHora}}
    </div>
   <div v-if="!disabled && !editing">
     <v-tooltip top>
       <template v-slot:activator="{ on }">
         <v-btn v-on="on" color="primary" icon @click="startEdit">
           <v-icon small>mdi-pencil</v-icon>
         </v-btn>
       </template>
       {{labelBtnEdit}}
     </v-tooltip>
     <v-tooltip top>
       <template v-slot:activator="{ on }">
         <v-btn v-on="on" color="primary" icon @click="excluirPagamento">
           <v-icon small>mdi-delete</v-icon>
         </v-btn>
       </template>
       {{labelBtnDelete}}
     </v-tooltip>
   </div>
    <div v-if="editing" class="container-edit-input">
      <input-valor
          v-model="model.valorPago"
          :name="'pag'+ model.id"
          label="Valor"
          placeholder="Informe o valor"
          :event-submit="'blur'"
          :prefix="prefixo"
          :suffix="sufixo"
          :precision="casasDecimais"
          hide-details
          @blur="(valor) => model.valorPago = valor"
          class-name="input-edit-pagamento"
      />
      <combo-enum
          v-model="model.formaPagamento"
          :name="'formaPag' + model.id"
          :enum-object="formasPagamento"
          :insertNullItem="false"
          hide-details
          outlined
          class-name="input-edit-forma-pagamento"
      >
        <template v-slot:label>
          Forma de pagamento
        </template>
      </combo-enum>
    </div>

    <div v-if="editing">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" icon @click="submitEdit">
            <v-icon small>fas fa-check</v-icon>
          </v-btn>
        </template>
        {{ labelBtnSave }}
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon @click="cancelEdit">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </template>
        {{ labelBtnCancel }}
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import InputValor from '@/views/components/InputValor.vue'
import ComboEnum from '@/views/components/ComboEnum.vue'
import formasPagamento from '@/core/constants/enums/formasPagamento'

export default {
    components: {ComboEnum, InputValor},
    inject: ['$validator'],
    name: 'campo-pagamento-editavel',
    props: {
        value: {
            required: true
        },
        name: {
            required: true,
            type: String
        },
        labelBtnSave: {
            type: String,
            default: 'Salvar'
        },
        labelBtnCancel: {
            type: String,
            default: 'Cancelar'
        },
        labelBtnEdit: {
            type: String,
            default: 'Editar'
        },
        labelBtnDelete: {
            type: String,
            default: 'Excluir'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            model: {
                id: null,
                valorPago: null,
                formaPagamento: null,
                dataPagamento: null,
            },
            editing: false,
            prefixo: 'R$',
            sufixo: '',
            casasDecimais: 2,
            formasPagamento
        }
    },
    methods: {
        startEdit() {
            this.model = _.cloneDeep(this.value)
            this.editing = true
        },
        async submitEdit() {
            this.editing = false
            this.$emit('editarPagamento', this.model)
        },
        excluirPagamento(){
            this.$emit('excluirPagamento', this.value)
        },
        cancelEdit() {
            this.editing = false
        },
    }
}
</script>

<style scoped lang="stylus">

.container-edit-pagamento
  display flex
  flex-direction row
  align-items center
  justify-content space-between

.container-edit-input
  display flex
  padding 5px 0px

.input-edit-pagamento
  height 40px !important
  width 120px
  >>>.v-input__slot
        min-height 40px !important

.input-edit-forma-pagamento
  margin-left 10px !important
  width 200px

@media (max-width: 720px)
  .text-edit
    .v-text-field
      max-width 100%

</style>
